/* 🤖 this file was generated by script */
export const wiconDataflow02 = {
  name: 'dataflow_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v11.2c0 1.68 0 2.52.33 3.16a3 3 0 001.3 1.31c.65.33 1.49.33 3.17.33h.2m0 0a2 2 0 104 0 2 2 0 00-4 0zM7 4h10M7 4a2 2 0 11-4 0 2 2 0 014 0zm10 0a2 2 0 104 0 2 2 0 00-4 0zm-5 8h5m0 0a2 2 0 104 0 2 2 0 00-4 0z"/></svg>`,
};
